<template>
  <VOverlay v-model="show" contained class="align-center justify-center">
    <VProgressCircular indeterminate :size="70" :width="7" color="primary" />
  </VOverlay>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Store
import { mapState } from "pinia";
import { useLoaderProgressStore } from "@/stores/loaderProgressStore";

export default defineComponent({
  name: "LoaderProgress",

  props: {
    isVisible: Boolean,
  },

  computed: {
    ...mapState(useLoaderProgressStore, ["loading"]),

    show: {
      get() {
        return this.loading;
      },
      set() {},
    },
  },
});
</script>

<style scoped>
.v-dialog--fullscreen .v-overlay__content {
  justify-content: center;
  align-items: center;
}
</style>
